/**
 * Collections the property bake strips because the edge worker loads them live.
 * Theme and block source must not read these off the property object.
 */
export const LIVE_COLLECTIONS = [
  'floorplans',
  'floorplans_full',
  'special_offers',
  'fees',
] as const;

export type LiveCollection = (typeof LIVE_COLLECTIONS)[number];

const LIVE_COLLECTION_NAMES: ReadonlySet<string> = new Set(LIVE_COLLECTIONS);

export function isLiveCollection(name: string): name is LiveCollection {
  return LIVE_COLLECTION_NAMES.has(name);
}

/**
 * Hooks whose zero-argument call returns the property object itself, raw or cast
 * to a record. Reading a live collection off the result is the same bug as
 * `property.fees`, so the linter treats a call to any of them as a property receiver.
 */
export const PROPERTY_HOOKS = ['useProperty', 'useRawProperty', 'usePropertyRecord'] as const;

/** True when a field path (`floorplans[0].units[0].unit_name`) starts at a live collection root. */
export function isLiveCollectionPath(path: string): boolean {
  return isLiveCollection(path.split(/[.[]/, 1)[0]);
}
